import { Router } from '@angular/router';
import { AuthService } from 'smarthub-core';
import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'ngx-logout',
  styleUrls: ['./logout.component.scss'],
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {



  constructor(
    private _authService: AuthService,
    private _router: Router,
  ) {
  }

  ngOnInit() {
    this._authService.signOut()
    //window.location.href = '/#//auth/login';
  }


}
